module.exports = __webpack_public_path__ + "img/dashboard.a88b51fe.svg";